/**
 * @biudon-dev/barca-chat-widget
 * Voice chat widget for BarcaMobile with ElevenLabs integration
 */

// Main components
export { BarcaChatWidget } from './components/BarcaChatWidget';
export { BarcaChatProvider } from './providers/BarcaChatProvider';

// Hooks
export { useBarcaChat } from './hooks/useBarcaChat';
export { useConversationHistory } from './hooks/useConversationHistory';
export { useWidgetManager } from './hooks/useWidgetManager';

// Widget Manager
export { widgetManager } from './lib/WidgetManager';
export type { WidgetState, WidgetType, WidgetManagerConfig } from './lib/WidgetManager';

// Types
export type {
    BarcaChatConfig,
    BarcaChatAPI,
    ChatMode,
    ConversationStatus,
    Message
} from './types';

// Individual components (for advanced usage)
export { BarcaChatConversation } from './components/BarcaChatConversation';
export { AudioIndicator } from './components/AudioIndicator';
export { ListeningPlaceholder } from './components/ListeningPlaceholder';
export { default as BackgroundStripes } from './components/BackgroundStripes';

// Provider context hook
export { useBarcaChatConfig } from './providers/BarcaChatProvider';
